import { render, staticRenderFns } from "./SolarRoofShape.vue?vue&type=template&id=3ffcc592"
import script from "./SolarRoofShape.vue?vue&type=script&lang=ts"
export * from "./SolarRoofShape.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports